
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landmarks",
      function () {
        return require("private-next-pages/landmarks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landmarks"])
      });
    }
  